<template>
  <bar :data="chartData" :options="options" :ref="queryID"/>
</template>

<script>
  import { Bar } from 'vue-chartjs'
  import ChartHelper from "./ChartHelper"
  import {Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale} from 'chart.js'

  ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

  export default {
  //  extends: Bar,
    props: ['chartType', 'queryColumns', 'queryResult', 'chartZoomResetKey', 'queryID'],
    components: {
      Bar
    },

    watch: {
      chartZoomResetKey(){
        this.$refs[this.queryID].chart.resetZoom()
      }
    },

    computed: {
      chartData() {
        if(this.queryResult && this.queryResult.length > 0){
          let dataset = ChartHelper.buildDataset(this.chartType, this.queryColumns, this.queryResult)
          console.log("dataset bar:", dataset)
          return dataset
        }
      },
      options () {
        if(this.queryResult && this.queryResult.length > 0){
          return {
            responsive: true,
            maintainAspectRatio: false,
            scaleBeginAtZero: true,
            animation: {
              duration: 0
            },
            plugins: {
              // Change options only for labels of THIS DATASET
              datalabels: this.chartData.labels.length<=3?{
                align: 'end',
                anchor: 'end',

                /*color: function(context) {
                  return context.dataset.backgroundColor;
                },*/

                // scriptable
                color: function(context) {
                  let index = context.dataIndex;
                  let value = context.dataset.data[index];
                  return value < 0 ? 'darkred' :  // draw negative values in red
                    context.dataset.fontColorLabel
                },

                // dont display:  0 values
                /*
                              display: function(context) {
                                let index = context.dataIndex;
                                let value = context.dataset.data[index];
                                return (value === 0) ? false : true
                              },
                */

                backgroundColor: function(context) { return context.dataset.backgroundColor },

                "padding": 5,
                "border": 0,

                font: function(context) {
                  var w = context.chart.width;
                  return {
                    size: w < 512 ? 12 : 14,
                    weight: 'bold',
                  }
                },

                borderRadius: 1,
                borderWidth: 0,
                borderColor: 'black',
                rotation: 0,

                formatter: function(value, context) {
                  //return value + '\n' + context.chart.data.labels[context.dataIndex];
                  return value;
                }
              }:false,
              /*
              zoom: {
                zoom: {
                  wheel: { enabled: true },
                  pinch: { enabled: true },
                  mode: 'xy',
                },
                pan: {
                  enabled: true,
                  mode: 'xy',
                }
              }*/
            }
          }
        }
      }
    }
  }
</script>


<style lang="sass">

</style>
